import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0F0F0F",
      "fill-rule": "evenodd",
      d: "m4.929 10 6.01 6.01L12 17.071l1.06-1.06L19.072 10l-1.06-1.06L12 14.95 5.99 8.94z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }